import React, { useEffect } from 'react';

import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';
import { useLocationContext } from 'state/location';
import { PYPESTREAM_INTERFACE_ID, usePypestreamContext } from 'state/pypestream';
import { routes } from 'utils/routing';

import { Container, Screen } from './styled';

export const PypestreamInterface = () => {
  const { visible, declareContainerReady, loading } = usePypestreamContext();
  const { location } = useLocationContext();

  const showLoadingState = location.pathname.startsWith(routes.support) && loading;

  useEffect(() => {
    declareContainerReady();
  }, [declareContainerReady]);

  return (
    <Screen visible={visible || showLoadingState}>
      {showLoadingState ? (
        <LoadingContainer>
          <LoadingAnimation fillColor={Styles.color.primary} />
        </LoadingContainer>
      ) : (
        <Container
          visible={visible}
          id={PYPESTREAM_INTERFACE_ID}
          data-testid={PYPESTREAM_INTERFACE_ID}
        />
      )}
    </Screen>
  );
};
